const getters = {
  msgNum: state => state.app.msgNum,
  socketFlag: state => state.app.socketFlag,
  isOpenid: state => state.app.isOpenid,
  pageAllData: state => state.app.pageAllData,
  breadListState: state => state.app.breadListState,
  user: state => state.app.user,
  roles: state => state.app.roles,
  routers: state => state.app.routers,
  isLogin: state => state.app.isLogin,
}
export default getters
